import Vue from 'vue'
import App from './App.vue'
import '@/assets/global/index.scss'
import router from './router'
import store from './store'
import init from './common/init'
import utils from './common/utils'
import constants from './common/constants'



Vue.prototype.$init = init
Vue.prototype.$utils = utils
Vue.prototype.$constants = constants


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')



